module.exports = require("@workbench-stack/core");